import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../../public/locales/en/common.json';
import sv from '../../public/locales/sv/common.json';
import fr from '../../public/locales/fr/common.json';
import es from '../../public/locales/es/common.json';
import de from '../../public/locales/de/common.json';
import pl from '../../public/locales/pl/common.json';

export const SUPPORTED = ['en', 'sv', 'fr', 'es', 'de', 'pl'] as const;
export type Locale = (typeof SUPPORTED)[number];

const RESOURCE_BUNDLES = {
  en,
  sv,
  fr,
  es,
  de,
  pl
} as const;

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      sv: { translation: sv },
      fr: { translation: fr },
      es: { translation: es },
      de: { translation: de },
      pl: { translation: pl }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnNull: false,
    returnEmptyString: false
  });
} else {
  // In development with HMR, `i18n` may already be initialized, which means newly added
  // keys in `common.json` won't be picked up unless we merge them into the resource store.
  (Object.keys(RESOURCE_BUNDLES) as Locale[]).forEach((lng) => {
    i18n.addResourceBundle(lng, 'translation', RESOURCE_BUNDLES[lng], true, true);
  });
}

// Add defensive detectLanguage method stub to prevent TypeError
// This method is expected by some dependencies but we handle language detection manually
if (!(i18n as TypeAny).detectLanguage) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (i18n as TypeAny).detectLanguage = (_input?: string) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        '[i18n] detectLanguage() called but language detection is handled manually. ' +
          'Current language:',
        i18n.language
      );
    }
    // Return current language if i18n is initialized, otherwise return null
    return i18n.isInitialized ? i18n.language : null;
  };
}

export default i18n;
